import { gql } from "@apollo/client";

export const USER_FIELDS_FRAGMENT = gql`
  fragment UserFields on User {
    id
    name
    login
    email
    phone
  }
`;

export const GET_USER = gql`
  ${USER_FIELDS_FRAGMENT}
  query Me {
    me {
      ...UserFields
    }
  }
`;

export const LOGIN_USER = gql`
  ${USER_FIELDS_FRAGMENT}
  mutation authentication($input: AuthenticationInput!) {
    authentication(input: $input) {
      ...UserFields
    }
  }
`;

export const REGISTER_USER = gql`
  mutation register($input: RegisterInput!) {
    register(input: $input) {
      ...UserFields
    }
  }
`;

export const LOGOUT_USER = gql`
  mutation Logout {
    logout
  }
`;
